module.exports = __webpack_public_path__ + "img/banner-index-1.722376a4.jpg";